var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsaveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H17L12 14M8 7H12L10 15M3 7H6L8 14M13 2H15L17 5H14M9 2H11L12 5H8M5 2H7L6 5H3M4 0L0 6L10 20L20 6L16 0H4Z",
    fill: "#EDEFF2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaveDark);
export default __webpack_public_path__ + "static/media/usaveDark.c6dc133fa0da32434cfef20441ff0cb0.svg";
export { ForwardRef as ReactComponent };